import React, { useState } from "react";
import "./styles.css";
import IndiaFlag from "../../assets/india-flag.svg";
import USAFlag from "../../assets/usa-flag.svg";
import ZolveLogo from "../../assets/zolve_logo.svg";
import LendingTreeLogo from "../../assets/lendingtree_logo.svg";
import { apiBaseUrl } from "../../lib/config";
// import { ArrowRightIcon } from "lucide-react";

// Tab Component
const TabComponent = ({ activeTab, onTabChange }) => (
  <div className="credit-card-tabs">
    <h2 className="credit-card-title">Build Your US Credit History</h2>
    <div className="tabContainer">
      <p className="tabLabel">I'm In</p>
      <div className="tabButtons">
        <button
          className={`tabButton ${activeTab === "zolve" ? "active" : ""}`}
          onClick={() => onTabChange("zolve")}
        >
          <img src={IndiaFlag} className="flag" alt="India" />
          <span>India</span>
        </button>
        <button
          className={`tabButton ${activeTab === "lendingtree" ? "active" : ""}`}
          onClick={() => onTabChange("lendingtree")}
        >
          <img src={USAFlag} className="flag" alt="USA" />
          <span>USA</span>
        </button>
      </div>
    </div>
  </div>
);

// Card Container Component
const CardContainer = ({ type, children, link, onApply }) => (
  <div
    className={`cardContainer ${
      type === "zolve" ? "zolveCard" : "lendingtreeCard"
    }`}
  >
    <div className="contentWrapper">{children}</div>
    {
      <div className="applyButton" onClick={onApply}>
        Apply Now{" "}
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5 12H19M19 12L12 5M19 12L12 19"
            stroke="#0D74BA"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    }
  </div>
);

// Card Header Component
const CardHeader = ({
  title,
  logo,
  heading_card,
  buttonText,
  buttonClass = "",
  knowMoreLink = "",
}) => (
  <div className="cardHeader ">
    <div className="logoContainer">
      <p className="head_card">{heading_card}</p>
    </div>
    {knowMoreLink && (
      <a href={knowMoreLink} target="_blank" rel="noopener noreferrer">
        {" "}
        <button className={`knowMoreButton ${buttonClass}`}>
          {buttonText}
        </button>
      </a>
    )}
  </div>
);


// Card Footer Component
const CardFooter = ({
  title,
  logo,
}) => (
  <div className="cardFooter ">
    <div className="logoFooter">
      <img src={logo} alt={`${title} Logo`} className="logo2" />      
    </div>
    
  </div>
);

// Feature Item Component
const FeatureItem = ({ text, isLendingtree = false }) => (
  <div className="featureItem">
    <div className={`checkIcon ${isLendingtree ? "lendingtreeCheckIcon" : ""}`}>
      <svg
        width="18"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="18" height="18" rx="9" fill="white" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.8223 5.5425L7.45226 10.725L6.02726 9.2025C5.76476 8.955 5.35226 8.94 5.05226 9.15C4.75976 9.3675 4.67726 9.75 4.85726 10.0575L6.54476 12.8025C6.70976 13.0575 6.99476 13.215 7.31726 13.215C7.62476 13.215 7.91726 13.0575 8.08226 12.8025C8.35226 12.45 13.5048 6.3075 13.5048 6.3075C14.1798 5.6175 13.3623 5.01 12.8223 5.535V5.5425Z"
          fill="#12B76A"
        />
      </svg>
    </div>
    <p className="featureText">{text}</p>
  </div>
);

// Card Content Component
const CardContent = ({ description,  features, isLendingtree = false }) => (
  <div className="cardContent">
    <p className="description mrgn-0">{description}</p>
    <div>
      {features.map((feature, index) => (
        <FeatureItem key={index} text={feature} isLendingtree={isLendingtree} />
      ))}
    </div>
  </div>
);

// Card Components
const ZolveCard = ({ thisApplication }) => {
  const features = [
    "No SSN needed, apply with passport and visa",
    "Up to $15,000* credit limit",
    "Instant approval & virtual card",
    "Zero annual fee",
  ];
  const handleApplyClick = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split(".");
    if (parts[0] === "www") parts.shift();
    const isSubdomain = parts.length > 2;
    const offerId = isSubdomain ? "40" : "91";

    const token = localStorage.getItem("access_token");
    fetch(
      `${apiBaseUrl}/api/v2/newsite/credit-card/create`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          credit_card_type: "zolve",
        }),
      }
    );

    fetch(`${apiBaseUrl}/applications/log_offer_click`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        offer_id: offerId,
        application_id: thisApplication?.id,
      }),
    }).catch((err) => console.error("Offer click log failed", err));

    window.open(
      "https://account.zolve.com/signup/email?utm_channel=affiliates&utm_source=affiliates_study_visa&utm_medium=email&utm_campaign=ST_US_CC_acquistion_17-06-25&utm_term=NA&utm_content=NA&utm_affiliate=Nomad_credit&referral_code=Nomad_credit",
      "_blank"
    );
  };
  return (
    <CardContainer type="zolve" link="/sign-in" onApply={handleApplyClick}>
       <CardHeader
      heading_card = "US Credit Card (without SSN)"      
     
        buttonText="Know More"
        knowMoreLink="/us-credit-card/no-ssn-required"
      />
      <CardContent
        description="Get a U.S. credit card before you even land in America. No SSN or U.S. address required."
         
        features={features}
      />
      <CardFooter
        title="Zolve"
        logo={ZolveLogo}
      />
    </CardContainer>
  );
};

const LendingtreeCard = ({ thisApplication }) => {
  const features = [
    "Quick online application and approval",
    "Trusted marketplace",
    "Personalized offers",
    "Bigger rewards and perks",
  ];
  const handleApplyClick = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split(".");
    if (parts[0] === "www") parts.shift();
    const isSubdomain = parts.length > 2;
    const offerId = isSubdomain ? "73" : "94";

    const token = localStorage.getItem("access_token");
    fetch(
      `${apiBaseUrl}/api/v2/newsite/credit-card/create`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          credit_card_type: "lendingtree",
        }),
      }
    );

    fetch(`${apiBaseUrl}/applications/log_offer_click`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: new URLSearchParams({
        offer_id: offerId,
        application_id: thisApplication?.id,
      }),
    }).catch((err) => console.error("Offer click log failed", err));

    window.open(
      "https://www.lendingtree.com/form/grove-light/cards/tq_2c?SpId=treequal-seo-monevo-mvp&esourceid=520290&cchannel=offline&csource=lendingtree.com&cepage=%2f&v1=LTBRD&v2=651a8d22-a41c-41e3-8e54-343634dc0305&sessionid=651a8d22-a41c-41e3-8e54-343634dc0305&mta=1",
      "_blank"
    );
  };
  return (
    <CardContainer
      type="lendingtree"
      link="/sign-in"
      onApply={handleApplyClick}
    >
       <p className="head_card">US Credit Card (with SSN/ITIN)</p>
      {/* <CardHeader
        title="LendingTree"
        logo={LendingTreeLogo}
        buttonText="Know More"
        buttonClass="lendingtreeButton"
      /> */}
      <CardContent
        description="Already in the U.S.? Compare and apply for top credit cards."
        features={features}
        isLendingtree={true}
      />
      <CardFooter
        title="LendingTree"
        logo={LendingTreeLogo}
      />
    </CardContainer>
  );
};

// Main Component
const USCreditCards = ({ thisApplication }) => {
  const [activeTab, setActiveTab] = useState("zolve");
  React.useEffect(() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    if (userTimezone.includes("America/")) {
      setActiveTab("lendingtree");
    }
  }, []);

  return (
    <div id="cards-section" className="credit-card-tabs credit-card-tab-container">
      <TabComponent activeTab={activeTab} onTabChange={setActiveTab} />
      {activeTab === "zolve" ? <ZolveCard thisApplication={thisApplication} /> : <LendingtreeCard thisApplication={thisApplication} />}
    </div>
  );
};

export default USCreditCards;
